import { IconButton, Tooltip, Zoom } from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme
} from '@material-ui/core/styles';
import { ExpandLessRounded } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toTop: {
      position: 'fixed',
      bottom: '1.5rem',
      left: '1.5rem',
      backgroundColor: 'rgba(238, 238, 238, 0.25)',
      color: theme.palette.primary.main,
      transition: '0.3s',
      '&:hover, &.Mui-focusVisible': {
        backgroundColor: 'rgba(238, 238, 238, 0.75)'
      },
      boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.1)',
      zIndex: 100
    }
  })
);

export default function ScrollTop({ showBelow }: { showBelow: number }) {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const [show, setShow] = useState(showBelow ? false : true);

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  function handleScroll() {
    if (window.pageYOffset > showBelow) {
      if (!show) setShow(true);
    } else {
      if (show) setShow(false);
    }
  }

  useEffect(() => {
    if (showBelow) {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  });

  function handleClick() {
    window['scrollTo']({ top: 0, behavior: 'smooth' });
  }

  return (
    <div>
      <Zoom
        in={show}
        timeout={transitionDuration}
        style={{
          transitionDelay: `${transitionDuration.exit}ms`
        }}
        unmountOnExit
      >
        <Tooltip title={t('scrollTopButton.backToTop') as string} arrow>
          <IconButton onClick={handleClick} className={classes.toTop}>
            <ExpandLessRounded />
          </IconButton>
        </Tooltip>
      </Zoom>
    </div>
  );
}
